import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import { isMobile } from 'react-device-detect';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  loadFileByUrl, showGlobalConfirm, showSignPopup, signDocument,
} from '../actions';
import { APPLICATION_STATUS, DOCUMENT_STATUS } from '../../../configs';
import {
  applicationFieldsValidation,
  assignApplicationById,
  deleteDocument,
  deniedApplication,
  generateDocx,
  returnApplication,
  reviewApplication, suspendedApplication, unAssignApplicationById,
} from '../../Application/actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  getResponseError, isDoc, nameBySave, responseLogWithNotification,
} from '../../../utils/utils';
import { dateFormatter } from '../../../utils/formatters';
import ApplicationReturn from '../../Application/components/ApplicationReturn';
import ApplicationDenied from '../../Application/components/ApplicationDenied';
import ApplicationSuspended from '../../Application/components/ApplicationSuspended';
import { FORBIDDEN } from '../../../configs/serverStatusCodes';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import ImportSignDocument from '../../Application/components/ImportSignDocument';
import DocxViewer from './DocxViewer';

export default function ViewDocument(props) {
  const {
    document = {},
    loadingSignDocument = false,
    isDownloadAvailable = true,
    isSignAvailable = false,
    prevCrumbs = null,
    handleClose = () => {},
    loadData = () => {},
    loadById = () => {},
    loadingCurrentApplication = false,
    loadingReturnApplication = false,
    loadingDeniedApplication = false,
    loadingSuspendedApplication = false,
    loadingCarrierExtractList = false,
    loadingVehicleExtractList = false,
    loadingSzltExtractList = false,
    loadDocuments = () => {},
  } = props;
  const dispatch = useDispatch();
  const {
    files, is_actual, status, notification_template,
  } = document;
  const signedFile = files.find(f => f.collection_name === 'signed');
  const unsignedFile = files.find(f => f.collection_name === 'unsigned');
  const signatureFile = files.find(f => f.collection_name === 'signature');
  const isLoading = loadingSignDocument || loadingCarrierExtractList || loadingVehicleExtractList || loadingSzltExtractList;
  const file = signedFile || unsignedFile;
  const [modal, setModal] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const application = document && document.context && document.context.application ? document.context.application : null;
  const unAssign = id => dispatch(unAssignApplicationById(id))
    .catch(response => {
      errorNotification('Загрузка обращения', getResponseError(response));
    });

  const afterSetEndStatus = () => {
    unAssign(application?.id).then(() => {
      loadData();
    });
  };

  const handleReturn = values => {
    dispatch(returnApplication({ id: application.id, values })).then(() => {
      afterSetEndStatus();
      setModal(false);
      handleClose();
      successNotification('Обработка обращения', 'Возвращено');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const handleAssign = id => {
    if (id) {
      dispatch(assignApplicationById(id))
        .then(() => {
          dispatch(applicationFieldsValidation({ id })).catch(responseLogWithNotification);
          setModal(true);
        })
        .catch(response => {
          setModal(false);
          if (response && response.status === FORBIDDEN) {
            return errorNotification('Загрузка обращения', 'Обращение обрабатывается другим пользователем');
          }
          errorNotification('Загрузка обращения', getResponseError(response));
        });
    }
  };

  const handleDenied = values => {
    dispatch(deniedApplication({ id: application.id, values })).then(() => {
      afterSetEndStatus();
      setModal(false);
      handleClose();
      successNotification('Обработка обращения', 'Отказано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const handleSuspended = values => {
    dispatch(suspendedApplication({ id: application.id, values })).then(() => {
      afterSetEndStatus();
      handleClose();
      setModal(false);
      successNotification('Обработка обращения', 'Приостановлено');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  const handleDownload = () => {
    dispatch(loadFileByUrl(file?.url))
      .then(data => {
        if (data) {
          const templateName = document && document.notification_template && document.notification_template.name
            ? document.notification_template.name
            : document.id;
          const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);
          fileDownload(data, file.file_name || name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const handleDownloadSig = () => {
    dispatch(loadFileByUrl(signatureFile?.url))
      .then(data => {
        if (data) {
          fileDownload(data, signatureFile.file_name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const handleDownloadDocx = () => {
    dispatch(generateDocx(document?.id || file.model_id))
      .then(data => {
        if (data) {
          const templateName = document && document.notification_template && document.notification_template.name;
          const name = `${templateName || document.type_label} ${document.number}.docx`;
          fileDownload(data, name);
        }
      })
      .catch(responseLogWithNotification);
  };
  const handleDelete = () => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление документа №${document.name}`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteDocument(document.id)).then(() => {
        loadData();
        handleClose();
        successNotification('Удаление документа', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление документа', getResponseError(response));
      });
    }).catch(() => {});
  };

  const handleSign = () => {
    dispatch(showSignPopup()).then(cert => {
      dispatch(signDocument({ cert, document }))
        .then(() => {
          successNotification('Подписание документа', 'Подписание прошло успешно');
          loadData();
          loadById(document.id);
          loadDocuments();
        })
        .catch(error => {
          errorNotification('Подписание документа', error || 'Ошибка подписания файла');
        });
    }).catch(() => {});
  };

  const handleReview = item => event => {
    if (!item) {
      return;
    }
    dispatch(showGlobalConfirm({
      confirmMessage: `Пересмотреть обращение № ${item.mais_egu_id || 'Без номера'}?`,
      confirmButtonText: 'Пересмотреть',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(reviewApplication(item.id)).then(() => {
        loadData();
        handleClose();
        successNotification('Отправка на пересмотр', 'Отправка на пересмотр прошла успешно');
      }).catch(response => {
        errorNotification('Отправка на пересмотр', getResponseError(response));
      });
    }).catch(() => {});
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="file-viewer-header">
            <div className="application-form-header">
              <div className="breadcrumbs">
                {prevCrumbs || null}
                <span className="breadcrumbs-current">
                  {document?.name || document?.notification_template?.name || 'Просмотр документа'} № {document?.number || 'Без номера'}
                </span>
              </div>
            </div>
            {signedFile
              ? (
                <div className="file-viewer-header-icon-wrapper">
                  <Icons customIcon icon="pencil" className="file-viewer-header-icon" />
                </div>
              )
              : null}
          </div>
            )}
        title={<Icons onClick={handleClose} customIcon icon="close" className="close" />}
      />
      <DialogContent>
        <Loader loading={isLoading} />
        {!isLoading ? (file && file?.url) && !isDoc(file.mime_type)
          ? <iframe title="Просмотр файла" src={file?.url} frameBorder="0" width="100%" height="100%" />
          : <DocxViewer src={file?.url} /> : null}
        {!isLoading && (!file || !file?.url) ? <div className="file-not-found">Файл не найден</div> : null}
        {isLoading && (<div className="file-not-found">Идет загрузка данных...</div>)}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownloadDocx}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Docx</span>
          </Button>
        ) : null}
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownload}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Pdf</span>
          </Button>
        ) : null}
        {isDownloadAvailable && signedFile ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownloadSig}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Sig</span>
          </Button>
        ) : null}
        <div className="ms-auto" />
        {!isMobile && application && application.id && status === DOCUMENT_STATUS.CREATED && [APPLICATION_STATUS.DENIED, APPLICATION_STATUS.RETURN, APPLICATION_STATUS.SUSPENDED].includes(notification_template?.application_status) && is_actual ? <Button variant="secondary" onClick={() => handleAssign(application.id)}>Редактировать</Button> : null }
        {!isMobile && application && application.id ? <Button variant="secondary" onClick={handleReview(application)}>На пересмотр</Button> : null }
        {!isMobile && isSignAvailable && !signedFile && is_actual ? <Button className="sign-button" disabled={isLoading || document?.type === 1} onClick={handleSign}>Подписать</Button> : null }
        {!isMobile && isSignAvailable && !signedFile && is_actual ? <Button className="import-button" disabled={isLoading || document?.type === 1} onClick={() => setShowImport(true)}>Импорт</Button> : null }
        <TimerLoader loading={loadingCurrentApplication || loadingReturnApplication || loadingDeniedApplication || loadingSuspendedApplication} />
        {modal && notification_template?.application_status === APPLICATION_STATUS.RETURN ? (
          <ApplicationReturn
            procedure={application?.procedure}
            send={handleReturn}
            buttonExecText="Изменить"
            close={() => setModal(false)}
          />
        ) : null}
        {modal && notification_template?.application_status === APPLICATION_STATUS.DENIED ? (
          <ApplicationDenied
            procedure={application?.procedure}
            send={handleDenied}
            buttonExecText="Изменить"
            close={() => setModal(false)}
          />
        ) : null}
        {modal && notification_template?.application_status === APPLICATION_STATUS.SUSPENDED ? (
          <ApplicationSuspended
            procedure={application?.procedure}
            send={handleSuspended}
            buttonExecText="Изменить"
            close={() => setModal(false)}
          />
        ) : null}
        {showImport && document ? (
          <ImportSignDocument
            document={document}
            handleClose={() => setShowImport(false)}
            loadData={loadData}
            loadById={loadById}
            loadDocuments={loadDocuments}
          />
        ) : null}
      </DialogFooter>
    </Dialog>
  );
}
